// modules/inicio/offline/syncRegistry.js
//
// Motor central de sincronización offline — mismo comportamiento que
// sincronizarPendientes()/contarTodosPendientes() del SI-PIC, pero en vez
// de un único archivo que importa a mano cada módulo del sistema, cada
// estrategia se "registra" acá con sus propias funciones. Así el motor
// central no necesita saber que existe Discapacidad, Vejez, etc. — solo
// sabe que hay una lista de proveedores con la misma forma.
//
// Cómo conectar una entidad nueva (ver registrarProveedoresSync.js):
//   registrarProveedorSync({
//     nombre: "discapacidad",       // clave interna (para el desglose)
//     etiqueta: "Discapacidad",     // texto para mostrar al usuario
//     contar: contarDiscapacidadPendientes,        // () => Promise<number>
//     sincronizar: sincronizarDiscapacidadPendientes, // () => Promise<number> (cuántos se sincronizaron)
//   });

const proveedores = [];

export function registrarProveedorSync(proveedor) {
  // Evita registrar el mismo proveedor dos veces si el módulo se importa
  // más de una vez (puede pasar con hot-reload en desarrollo).
  if (proveedores.some(p => p.nombre === proveedor.nombre)) return;
  proveedores.push(proveedor);
}

// Cuenta pendientes de TODAS las entidades registradas, en paralelo.
// Devuelve { total, desglose: { <nombre>: cantidad } }.
export async function contarTodosPendientes() {
  const resultados = await Promise.all(
    proveedores.map(async (p) => {
      try {
        return { nombre: p.nombre, etiqueta: p.etiqueta, cantidad: await p.contar() };
      } catch (e) {
        console.error(`Error contando pendientes de "${p.nombre}":`, e);
        return { nombre: p.nombre, etiqueta: p.etiqueta, cantidad: 0 };
      }
    })
  );

  const desglose = {};
  let total = 0;
  resultados.forEach(r => {
    desglose[r.nombre] = { cantidad: r.cantidad, etiqueta: r.etiqueta };
    total += r.cantidad;
  });

  return { total, desglose };
}

// Sincroniza TODAS las entidades registradas y dispara "sync-completado"
// una sola vez al final (no una vez por entidad) — así cualquier tabla que
// esté escuchando ese evento recarga una sola vez, no en cascada.
export async function sincronizarTodosPendientes() {
  const resultados = await Promise.all(
    proveedores.map(async (p) => {
      try {
        const cantidad = await p.sincronizar();
        return { nombre: p.nombre, etiqueta: p.etiqueta, cantidad };
      } catch (e) {
        console.error(`Error sincronizando "${p.nombre}":`, e);
        return { nombre: p.nombre, etiqueta: p.etiqueta, cantidad: 0, error: true };
      }
    })
  );

  const desglose = {};
  let total = 0;
  let huboError = false;
  resultados.forEach(r => {
    desglose[r.nombre] = { cantidad: r.cantidad, etiqueta: r.etiqueta };
    total += r.cantidad;
    if (r.error) huboError = true;
  });

  if (total > 0) {
    window.dispatchEvent(new CustomEvent("sync-completado", { detail: desglose }));
  }

  return { total, desglose, huboError };
}
